import { render, staticRenderFns } from "./Renders.vue?vue&type=template&id=37b3059c"
import script from "./Renders.vue?vue&type=script&lang=js"
export * from "./Renders.vue?vue&type=script&lang=js"
import style0 from "./Renders.vue?vue&type=style&index=0&id=37b3059c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports